import moment from "moment";

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function calcDate(timeStamp) {
  var date = new Date(timeStamp);
  var day = ("0" + date.getDate()).slice(-2);
  //var month = monthNames[date.getMonth()];
  var month = date.getMonth() + 1;
  var year = date.getFullYear();
  var finalDate = day + "/" + month + "/" + year;
  return finalDate;
}

export function calcDayDateYearTime(timeStamp) {
  var date = new Date(timeStamp);
  var day = ("0" + date.getDate()).slice(-2);
  //var month = monthNames[date.getMonth()];
  var month = date.getMonth() + 1;
  var year = date.getFullYear();
  var time = date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  var finalDate = day + "th" + month + "," + year + " " + time;
  return finalDate;
}

export function findDiffTwoDates(timestamp) {
  //var toTime = timestamp.toTime();
  var todaysDate = new Date();
  var difference = todaysDate - timestamp;
  var daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);

  return daysDifference;
}


export const toTimestamp=(date)=>{
  let convertDate = moment(date).format("DD-MM-YYYY");
  let dateTime = moment(convertDate + " " + date, "DD-MM-YYYY hh:mm A").format(
        "YYYY-MM-DD HH:mm:ss"
      );
  let timestamp = moment(dateTime).format("x");
  return timestamp
 }